// extracted by mini-css-extract-plugin
var _1 = "buttons-container__eJOtZ";
var _2 = "content__CGmTK";
var _3 = "content-wrapper__yK2by";
var _4 = "page-content__atPFE";
var _5 = "page-wrapper__n_3ZW";
var _6 = "page-wrapper--no-styling__BC9mP";
export { _1 as "buttons-container", _2 as "content", _3 as "content-wrapper", _4 as "page-content", _5 as "page-wrapper", _6 as "page-wrapper--no-styling" }
